import { pickBy } from 'lodash';
import { maybe } from '@passionware/monads';
import { ApiClient } from '../../../lib/api/ApiClient.types';
import { parseWithDecoratedError } from '../../../v4/entities/common/parseWithDecoratedError';
import {
  SystemSettingsApi,
  SystemSetting,
  UpsertSystemSettingInput,
  UpsertSystemSettingsInput,
  GetSystemSettingsInput,
  DeleteSystemSettingInput
} from './system-settings.api';
import {
  systemSettingHttp$,
  systemSettingsListHttp$
} from './system-settings.http.schema';

function systemSettingFromHttp(raw: unknown): SystemSetting {
  return parseWithDecoratedError(systemSettingHttp$, raw);
}

export function createSystemSettingsApi(client: ApiClient): SystemSettingsApi {
  return {
    async getSettings({
      enterpriseWorkspaceId,
      enterpriseTeamId
    }: GetSystemSettingsInput) {
      const response = await client.get(`/system-settings`, {
        token: true,
        params: pickBy(
          { enterpriseWorkspaceId, enterpriseTeamId },
          maybe.isPresent
        )
      });
      return parseWithDecoratedError(systemSettingsListHttp$, response).map(
        systemSettingFromHttp
      );
    },

    async upsertSetting({
      name,
      setting,
      enterpriseWorkspaceId,
      enterpriseTeamId
    }: UpsertSystemSettingInput) {
      const response = await client.put(`/system-settings/${name}`, {
        token: true,
        data: pickBy(
          { setting, enterpriseWorkspaceId, enterpriseTeamId },
          maybe.isPresent
        )
      });
      return systemSettingFromHttp(response);
    },

    async upsertSettings({
      settings,
      enterpriseWorkspaceId,
      enterpriseTeamId
    }: UpsertSystemSettingsInput) {
      const response = await client.put(`/system-settings`, {
        token: true,
        data: pickBy(
          { settings, enterpriseWorkspaceId, enterpriseTeamId },
          maybe.isPresent
        )
      });
      return parseWithDecoratedError(systemSettingsListHttp$, response).map(
        systemSettingFromHttp
      );
    },

    async deleteSetting({
      name,
      enterpriseWorkspaceId,
      enterpriseTeamId
    }: DeleteSystemSettingInput) {
      await client.del(`/system-settings/${name}`, {
        token: true,
        params: pickBy(
          { enterpriseWorkspaceId, enterpriseTeamId },
          maybe.isPresent
        )
      });
    }
  };
}
